import {
    PROTOCOL_SLASH_EXCLUDED_FIELD_PREFIXES,
    PROTOCOL_SLASH_EXCLUDED_FIELDS,
    PROTOCOL_SUGGESTION_VALUE,
} from 'features/stepByStepProtocol/utils/protocol/constants';

const isExcluded = (dataField) =>
    PROTOCOL_SLASH_EXCLUDED_FIELDS.has(dataField) || PROTOCOL_SLASH_EXCLUDED_FIELD_PREFIXES.some((prefix) => dataField.startsWith(prefix));

// Whether the Submit / Ctrl+Enter fill can write `/` into the field. Mirrors `resolveQuickSubmitFillTarget`
// (store/formControlSlice/fieldControllers.js): a closed list takes `/` only when it has a `/` option, so a
// chip on any other closed list would promise a value the fill never writes.
const acceptsSlash = ({ lookup, referenceField, restrictToOptions }) => {
    if (!lookup?.displayExpr || referenceField || restrictToOptions === false) return true;
    return (lookup.dataSource ?? []).some((option) => option?.[lookup.displayExpr] === PROTOCOL_SUGGESTION_VALUE);
};

/**
 * Protocol suggestions for a resolved path, as `{ [fieldName]: '/' }`: `/` for every field of the AIQ form
 * that the case's XML form does not list. The XML fields are left to the transaction's own values and
 * suggestions; `required` in the XML plays no part. Nothing for an unmatched case (no type, `/`, a type
 * the protocol does not expect), for read-only fields, or for fields with their own fill logic.
 */
export function buildProtocolSuggestions(path, formFields) {
    if (!path?.caseMatched || !Array.isArray(formFields)) return {};

    const protocolFieldNames = new Set(path.formFields.map(({ name }) => name));

    return formFields.reduce((suggestions, field) => {
        const dataField = field?.dataField;
        if (typeof dataField !== 'string' || !dataField || field.editable === false) return suggestions;
        if (protocolFieldNames.has(dataField) || isExcluded(dataField) || !acceptsSlash(field)) return suggestions;

        suggestions[dataField] = PROTOCOL_SUGGESTION_VALUE;
        return suggestions;
    }, {});
}
